/* Article — Body — page script bundle.
   Reading progress bar, hero parallax (desktop), auto-link plain URLs in
   the body, product / video embed hydration, and ALL-CAPS section-title
   tagging. Loaded with defer in sections/blog-article.liquid. */

(function () {
  'use strict';

  /* ── lifecycle state ──────────────────────────────────────────────────
     Customizer hot-swap fires shopify:section:load on the article section
     (and shopify:section:unload before that). Without explicit teardown,
     every reload added a fresh scroll listener and IntersectionObserver
     against the new DOM while the old ones kept running against detached
     nodes — slow accumulation over the editing session. Track everything
     we register so the unload handler can disconnect cleanly. */
  var _booted = false;
  var _scrollHandlers = [];
  var _observers = [];

  function _trackScroll(handler) {
    window.addEventListener('scroll', handler, { passive: true });
    _scrollHandlers.push(handler);
  }

  function _trackObserver(o) { _observers.push(o); }

  function teardown() {
    _scrollHandlers.forEach(function (h) {
      window.removeEventListener('scroll', h);
    });
    _scrollHandlers = [];
    _observers.forEach(function (o) {
      try { o.disconnect(); } catch (_) {}
    });
    _observers = [];
    _booted = false;
  }

  /* ── helpers ──────────────────────────────────────────────────────── */
  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
  function escapeAttr(s) {
    return s.replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
  }

  /* ── reading progress — bar lives in layout/blog.liquid ──────────── */
  function initReadingProgress() {
    var bar = document.getElementById('blog-reading-progress');
    if (!bar) return;

    var ticking = false;
    function updateProgress() {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight;
      var winHeight = window.innerHeight;
      var progress = scrollTop / (docHeight - winHeight);
      progress = Math.min(Math.max(progress, 0), 1);
      bar.style.transform = 'scaleX(' + progress + ')';
      ticking = false;
    }

    _trackScroll(function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateProgress);
      }
    });
  }

  /* ── hero parallax — desktop only, paused when off-screen ────────── */
  function initHeroParallax() {
    var hero = document.getElementById('blog-article-hero');
    if (!hero) return;

    var img = hero.querySelector('img');
    if (!img) return;

    if (!window.matchMedia('(min-width: 768px)').matches) return;

    var ticking = false;
    var isVisible = true;

    var visObserver = new IntersectionObserver(function (entries) {
      isVisible = entries[0].isIntersecting;
    }, { threshold: 0 });
    visObserver.observe(hero);
    _trackObserver(visObserver);

    function onScroll() {
      if (!isVisible || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollY = window.scrollY;
        img.style.transform = 'translateY(' + (scrollY * -0.15) + 'px)';
        ticking = false;
      });
    }

    _trackScroll(onScroll);
  }

  /* ── auto-links — wrap bare URLs in body text in <a> ─────────────── */
  function initAutoLinks() {
    var body = document.querySelector('.blog-article__body');
    if (!body) return;

    var URL_RE = /(https?:\/\/[^\s<>"')\]]+)/;
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (URL_RE.test(node.textContent) && !node.parentElement.closest('a')) {
        nodes.push(node);
      }
    }

    nodes.forEach(function (textNode) {
      var parts = textNode.textContent.split(URL_RE);
      if (parts.length <= 1) return;
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (URL_RE.test(part)) {
          var a = document.createElement('a');
          a.href = part;
          a.target = '_blank';
          a.rel = 'noopener';
          a.textContent = part;
          frag.appendChild(a);
        } else {
          frag.appendChild(document.createTextNode(part));
        }
      });
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  /* ── product embeds — fetch /products/{handle}.js, render card ──── */
  function initProductCards() {
    var embeds = document.querySelectorAll('.sb-product-embed[data-handle]');
    if (embeds.length === 0) return;

    embeds.forEach(function (el) {
      var handle = el.dataset.handle;
      if (!handle) return;
      el.classList.add('sb-product-embed--loading');

      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (product) {
          el.classList.remove('sb-product-embed--loading');
          renderProductCard(el, product);
        })
        .catch(function () { el.style.display = 'none'; });
    });
  }

  function renderProductCard(el, product) {
    var img = product.featured_image || '';
    var title = product.title || '';
    var price = product.price ? ('€' + (product.price / 100).toFixed(2).replace('.', ',')) : '';
    var url = '/products/' + product.handle;
    var html = '';
    if (img) {
      html += '<div class="sb-product-embed__image"><img src="' + escapeAttr(img) +
              '" alt="' + escapeAttr(title) + '" loading="lazy"></div>';
    }
    html += '<div class="sb-product-embed__info">';
    html += '<p class="sb-product-embed__title">' + escapeHtml(title) + '</p>';
    if (price) html += '<p class="sb-product-embed__price">' + price + '</p>';
    html += '<a href="' + escapeAttr(url) + '" class="sb-product-embed__cta">View Product</a></div>';
    el.innerHTML = html;
  }

  /* ── video embeds — YouTube + Vimeo iframe hydration ─────────────── */
  function initVideoEmbeds() {
    document.querySelectorAll('.sb-video-embed[data-video-url]').forEach(function (el) {
      var url = el.dataset.videoUrl;
      if (!url) return;

      var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      if (yt) {
        el.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + yt[1] +
                       '?rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
        return;
      }

      var vm = url.match(/vimeo\.com\/(\d+)/);
      if (vm) {
        el.innerHTML = '<iframe src="https://player.vimeo.com/video/' + vm[1] +
                       '?dnt=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
      }
    });
  }

  /* ── section titles — ALL-CAPS paragraphs become section dividers.
     Most all-caps blocks are now promoted to <h2>/<h3> by the
     rewrite-headings Liquid snippet (fix #1), but this remains as a
     belt-and-braces visual styling for any short all-caps <p> that
     fell below the 15-char threshold the snippet uses. */
  function initSectionTitles() {
    document.querySelectorAll('.blog-article__body > p').forEach(function (p) {
      var t = p.textContent.trim();
      if (t.length > 3 && t === t.toUpperCase() && /[A-Z]/.test(t)) {
        p.classList.add('blog-article__section-title');
      }
    });
  }

  /* ── ensure every body heading has a stable id for deep-linking.
     Rewritten headings already have slug ids from the Liquid snippet
     (fix #1); this catches original <h2>/<h5>/etc. that came from the
     editor without ids. (fix #8) */
  function initHeadingIds() {
    var sel = '.blog-article__body h2, .blog-article__body h3, ' +
              '.blog-article__body h4, .blog-article__body h5, ' +
              '.blog-article__body h6';
    var seen = {};
    document.querySelectorAll(sel).forEach(function (h) {
      if (h.id) { seen[h.id] = true; return; }
      var slug = (h.textContent || '').trim().toLowerCase()
                  .replace(/[^a-z0-9]+/g, '-')
                  .replace(/^-+|-+$/g, '');
      if (!slug) return;
      // De-dupe with -2, -3 suffix if same slug used twice in one article
      var unique = slug;
      var n = 2;
      while (seen[unique]) { unique = slug + '-' + n; n++; }
      seen[unique] = true;
      h.id = unique;
    });
  }

  /* ── boot ─────────────────────────────────────────────────────────── */
  function boot() {
    if (_booted) return;  /* idempotent — section:load + DOMContentLoaded
                             can fire in either order during Customizer
                             initial render */
    _booted = true;
    initReadingProgress();
    initHeroParallax();
    initAutoLinks();
    initProductCards();
    initVideoEmbeds();
    initSectionTitles();
    initHeadingIds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Customizer hot-swap: previous DOM is removed, fresh DOM is inserted.
     Tear down old observers/listeners then re-init on the new DOM. We
     match on the article-body or hero selectors so this only runs when
     the article section itself reloaded (not every section load). */
  function _isArticleSectionEvent(e) {
    if (!e || !e.target) return false;
    return Boolean(
      e.target.querySelector('.blog-article__body') ||
      e.target.querySelector('#blog-article-hero')
    );
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (_isArticleSectionEvent(e)) teardown();
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (_isArticleSectionEvent(e)) {
      teardown();
      boot();
    }
  });
})();
